import { ScreenHeader, showToast } from '../../../ui';
import { bulkCategorize } from '../../../data/commands/spending';
import { useCommandEnv } from '../../../data/hooks';
import { copy, SPENDING_BACK } from '../copy';
import { useCategories, useNoteHistory, useToday, useUncategorized } from '../hooks';
import { SCREEN } from '../styles';
import { TidyUpView } from './TidyUpView';

export function TidyUpScreen() {
  const env = useCommandEnv();
  const today = useToday();
  const entries = useUncategorized();
  const categories = useCategories() ?? [];
  const noteHistory = useNoteHistory() ?? [];

  async function onCategorize(ids: string[], categoryId: string) {
    await bulkCategorize(env, ids, categoryId);
    showToast({
      message: copy.categorized(ids.length),
      action: { label: copy.undo, onPress: () => void bulkCategorize(env, ids, null) },
    });
  }

  return (
    <main className={`${SCREEN} md:max-w-2xl`}>
      <ScreenHeader title={copy.tidyTitle} back={SPENDING_BACK} />
      {entries === undefined ? (
        <p className="text-muted">{copy.loading}</p>
      ) : (
        <TidyUpView
          entries={entries}
          categories={categories}
          noteHistory={noteHistory}
          today={today}
          onCategorize={onCategorize}
        />
      )}
    </main>
  );
}
